import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask4400To4499Service {

  constructor() { }
}
